import * as React from 'react';

function VacationCalendar() {
  return (
    <svg
      width="92"
      height="100"
      viewBox="0 0 92 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_27085_69977)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M86.9155 100C88.264 100 89.5572 99.4577 90.5108 98.4925C91.4643 97.5272 92 96.2181 92 94.853V37.9402H0V94.853C0 96.2181 0.53569 97.5272 1.48923 98.4925C2.44276 99.4577 3.73603 100 5.08453 100H86.9155Z"
          fill="#F4F5F6"
        />
        <path
          d="M40.3859 45.4082H35.6019C33.8857 45.4082 32.4944 46.8166 32.4944 48.5539V53.3915C32.4944 55.1289 33.8857 56.5372 35.6019 56.5372H40.3859C42.1022 56.5372 43.4935 55.1289 43.4935 53.3915V48.5539C43.4935 46.8166 42.1022 45.4082 40.3859 45.4082Z"
          fill="#D3D7DC"
        />
        <path
          d="M40.3859 63.4071H35.6019C33.8857 63.4071 32.4944 64.8155 32.4944 66.5528V71.3904C32.4944 73.1278 33.8857 74.5362 35.6019 74.5362H40.3859C42.1022 74.5362 43.4935 73.1278 43.4935 71.3904V66.5528C43.4935 64.8155 42.1022 63.4071 40.3859 63.4071Z"
          fill="#D3D7DC"
        />
        <path
          d="M72.6053 63.4185H67.8213C66.105 63.4185 64.7137 64.8268 64.7137 66.5642V71.4018C64.7137 73.1391 66.105 74.5475 67.8213 74.5475H72.6053C74.3216 74.5475 75.7129 73.1391 75.7129 71.4018V66.5642C75.7129 64.8268 74.3216 63.4185 72.6053 63.4185Z"
          fill="#D3D7DC"
        />
        <path
          d="M72.6053 45.4082H67.8213C66.105 45.4082 64.7137 46.8166 64.7137 48.5539V53.3915C64.7137 55.1289 66.105 56.5372 67.8213 56.5372H72.6053C74.3216 56.5372 75.7129 55.1289 75.7129 53.3915V48.5539C75.7129 46.8166 74.3216 45.4082 72.6053 45.4082Z"
          fill="#D3D7DC"
        />
        <path
          d="M56.4952 63.4185H51.7112C49.9949 63.4185 48.6036 64.8268 48.6036 66.5642V71.4018C48.6036 73.1391 49.9949 74.5475 51.7112 74.5475H56.4952C58.2114 74.5475 59.6028 73.1391 59.6028 71.4018V66.5642C59.6028 64.8268 58.2114 63.4185 56.4952 63.4185Z"
          fill="#EB4755"
        />
        <path
          d="M56.4952 45.4082H51.7112C49.9949 45.4082 48.6036 46.8166 48.6036 48.5539V53.3915C48.6036 55.1289 49.9949 56.5372 51.7112 56.5372H56.4952C58.2114 56.5372 59.6028 55.1289 59.6028 53.3915V48.5539C59.6028 46.8166 58.2114 45.4082 56.4952 45.4082Z"
          fill="#D3D7DC"
        />
        <path
          d="M23.9936 63.4071H19.2096C17.4934 63.4071 16.1021 64.8155 16.1021 66.5528V71.3904C16.1021 73.1278 17.4934 74.5362 19.2096 74.5362H23.9936C25.7099 74.5362 27.1012 73.1278 27.1012 71.3904V66.5528C27.1012 64.8155 25.7099 63.4071 23.9936 63.4071Z"
          fill="#D3D7DC"
        />
        <path
          d="M40.3859 81.4341H35.6019C33.8857 81.4341 32.4944 82.8425 32.4944 84.5798V89.4174C32.4944 91.1547 33.8857 92.5631 35.6019 92.5631H40.3859C42.1022 92.5631 43.4935 91.1547 43.4935 89.4174V84.5798C43.4935 82.8425 42.1022 81.4341 40.3859 81.4341Z"
          fill="#D3D7DC"
        />
        <path
          d="M56.4962 81.4341H51.7122C49.9959 81.4341 48.6046 82.8425 48.6046 84.5798V89.4174C48.6046 91.1547 49.9959 92.5631 51.7122 92.5631H56.4962C58.2124 92.5631 59.6037 91.1547 59.6037 89.4174V84.5798C59.6037 82.8425 58.2124 81.4341 56.4962 81.4341Z"
          fill="#D3D7DC"
        />
        <path
          d="M72.6053 81.4341H67.8213C66.105 81.4341 64.7137 82.8425 64.7137 84.5798V89.4174C64.7137 91.1547 66.105 92.5631 67.8213 92.5631H72.6053C74.3216 92.5631 75.7129 91.1547 75.7129 89.4174V84.5798C75.7129 82.8425 74.3216 81.4341 72.6053 81.4341Z"
          fill="#D3D7DC"
        />
        <path
          d="M23.9936 81.4341H19.2096C17.4934 81.4341 16.1021 82.8425 16.1021 84.5798V89.4174C16.1021 91.1547 17.4934 92.5631 19.2096 92.5631H23.9936C25.7099 92.5631 27.1012 91.1547 27.1012 89.4174V84.5798C27.1012 82.8425 25.7099 81.4341 23.9936 81.4341Z"
          fill="#D3D7DC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M86.9155 6.91443H5.08453C3.73603 6.91443 2.44276 7.4567 1.48923 8.42195C0.53569 9.3872 0 10.6964 0 12.0614L0 37.9433H92V12.0614C92 11.3855 91.8685 10.7162 91.613 10.0918C91.3574 9.46729 90.9829 8.89989 90.5108 8.42195C90.0386 7.94401 89.4781 7.56488 88.8612 7.30622C88.2443 7.04756 87.5832 6.91443 86.9155 6.91443Z"
          fill="#848FFF"
        />
        <path d="M92 24.3297H0V37.9433H92V24.3297Z" fill="#B8BEFF" />
        <path
          d="M18.91 21.1425C22.2527 21.1425 24.9626 18.3994 24.9626 15.0156C24.9626 11.6318 22.2527 8.88867 18.91 8.88867C15.5673 8.88867 12.8574 11.6318 12.8574 15.0156C12.8574 18.3994 15.5673 21.1425 18.91 21.1425Z"
          fill="white"
        />
        <path
          d="M18.9101 0H18.9091C17.4972 0 16.3525 1.15868 16.3525 2.58798V15.1895C16.3525 16.6188 17.4972 17.7775 18.9091 17.7775H18.9101C20.3221 17.7775 21.4667 16.6188 21.4667 15.1895V2.58798C21.4667 1.15868 20.3221 0 18.9101 0Z"
          fill="#121D2B"
          fillOpacity="0.6"
        />
        <path
          d="M73.0898 21.1425C76.4326 21.1425 79.1424 18.3994 79.1424 15.0156C79.1424 11.6318 76.4326 8.88867 73.0898 8.88867C69.7471 8.88867 67.0372 11.6318 67.0372 15.0156C67.0372 18.3994 69.7471 21.1425 73.0898 21.1425Z"
          fill="white"
        />
        <path
          d="M73.09 0H73.0889C71.677 0 70.5323 1.15868 70.5323 2.58798V15.1895C70.5323 16.6188 71.677 17.7775 73.0889 17.7775H73.09C74.5019 17.7775 75.6465 16.6188 75.6465 15.1895V2.58798C75.6465 1.15868 74.5019 0 73.09 0Z"
          fill="#121D2B"
          fillOpacity="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_27085_69977">
          <rect width="92" height="100" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default VacationCalendar;
